// Groupes : type (accompagnement, supplément), règle de choix, options et produits
export const loadOptionGroups = () => {
    return window.axios.get('get/product/option/groups')
}

export const createOptionGroup = (context, data) => {
    return window.axios.post('store/product/option/group', data)
}

export const updateOptionGroup = (context, { id, data }) => {
    return window.axios.patch('update/product/option/group/' + id, data)
}

export const deleteOptionGroup = (context, id) => {
    return window.axios.delete('delete/product/option/group/' + id)
}

// Bibliothèque d'options (noms saisis une fois, choisis dans les groupes)
// product_sale_element_id : article dont l'option décompte le stock (null = option libre) ;
// kind : FOOD (plat) ou DRINK (boisson) ; default_price : prix repris dans les groupes
// (sans prix, une option reliée reprend celui de son article)
export const createOption = (context, { name, product_sale_element_id = null, kind = 'FOOD', default_price = null }) => {
    return window.axios.post('store/product/option', { name, product_sale_element_id, kind, default_price })
}

export const updateOption = (context, { id, name, product_sale_element_id = null, kind = null, default_price = null }) => {
    return window.axios.patch('update/product/option/' + id, { name, product_sale_element_id, kind, default_price })
}

export const deleteOption = (context, id) => {
    return window.axios.delete('delete/product/option/' + id)
}

// Raccourci : option d'un article du catalogue (« Coca-Cola »), retrouvée ou créée côté API
export const optionFromProduct = (context, { productSaleElementId, kind = 'FOOD' }) => {
    return window.axios.post('store/product/option/from-product', { product_sale_element_id: productSaleElementId, kind })
}
